require("./vendor/routie.js"); // Global

const routeChangeDispatchers = require("./events/routeChange/routeChangeDispatchers.js");

const router = {
    Start() {
        console.log("Watching the route for changes.");

        routie({
            "survey-list*"(query) {
                const searchParams = getQueryParams(query);

                routeChangeDispatchers.ChangedToSurveyList(searchParams);
            },
            "walk-thru/:type/:facNumber/:id"(type, facNumber, id) {
                routeChangeDispatchers.ChangedToWalkThru(type, facNumber, id);
            },
            "survey/:type/:facNumber/:id/:pageID?/:sectionID?"(type, facNumber, id, pageID, sectionID) {
                routeChangeDispatchers.ChangedToSurvey(type, facNumber, id, pageID, sectionID);
            },
            "survey-confirmation/:type/:facNumber/:id"(type, facnumber, id) {
                routeChangeDispatchers.ChangedToSurveyConfirmation(type, facnumber, id); 
            },
            "survey-summary/:type/:facNumber/:id"(type, facNumber, id) {
                routeChangeDispatchers.ChangedToSurveySummary(type, facNumber, id);
            },
            "legacy-survey/:type/:facNumber/:id"(type, facNumber, id) {
                routeChangeDispatchers.ChangedToLegacySurvey(type, facNumber, id);
            },
            "survey-impersonation"() {
                routeChangeDispatchers.ChangedToImpersonation();
            },
            "reports"() {
                routeChangeDispatchers.ChangedToReports();
            },
            "*"() {
                routeChangeDispatchers.ChangedToSurveyList({});
            }
        })
    }
}

function getQueryParams(path) {
    const matches = /\?(.*)/.exec(path);

    if (matches) {
        const query = matches[matches.length - 1];

        const segs = query.split("&");

        const params = segs.reduce((agg, arg) => {
            const pair = arg.split("=");

            const key = decodeURIComponent(pair[0]);

            if (pair.length > 1) {
                agg[key] = decodeURIComponent(pair[1]);
            }
            else {
                agg[key] = true;
            }

            return agg;
        }, {});

        return params;
    }
}

module.exports = router;


// WEBPACK FOOTER //
// ./src/router.js